import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "zaiku",
  "use": "zaiku-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"zaiku\"><path d=\"M674.133333 768H853.333333v85.333333h-179.2l46.933334 46.933334-59.733334 59.733333L512 810.666667l149.333333-149.333334 59.733334 59.733334-46.933334 46.933333z m179.2-85.333333h-85.333333v-136.533334l-256-256-256 256V768h213.333333v85.333333H170.666667v-298.666666H128l384-384 384 384h-42.666667v128z m-422.4-213.333334h170.666667v85.333334h-170.666667v-85.333334z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol